import SkyMap from './SkyMap';

// Renders the "what am I looking at" panel for a resolved sky object: a styled
// sky-locator chart plus a table of the object's fixed astronomical facts and a
// short factual blurb. All data comes from src/data/skyObjects.json.

const ObjectFactsCard = ({ object }) => {
    if (!object) {
        return null;
    }

    const facts = [
        { label: 'Type', value: object.type },
        {
            label: 'Constellation',
            value: object.constellationMeaning
                ? `${object.constellation} (${object.constellationMeaning})`
                : object.constellation
        },
        { label: 'Distance', value: object.distanceLyText },
        {
            label: 'Apparent magnitude',
            value: object.apparentMagnitude != null ? String(object.apparentMagnitude) : null
        },
        { label: 'Apparent size', value: object.apparentSize },
        {
            label: 'Also known as',
            value: object.alsoKnownAs?.length ? object.alsoKnownAs.join(', ') : null
        },
        {
            label: 'Discovered',
            value: object.discoveredBy
                ? `${object.discoveredBy}${object.discoveredYear ? `, ${object.discoveredYear}` : ''}`
                : null
        }
    ].filter((fact) => fact.value);

    return (
        <section className="image-metadata-card sky-object-card">
            <h2>About this object</h2>

            <div className="sky-object-headline">
                <span className="sky-object-name">{object.primaryName}</span>
                {object.catalogIds?.length ? (
                    <span className="sky-object-catalog">{object.catalogIds.join(' · ')}</span>
                ) : null}
            </div>

            <SkyMap object={object} />

            <dl className="sky-object-facts">
                {facts.map((fact) => (
                    <div className="sky-object-fact" key={fact.label}>
                        <dt>{fact.label}</dt>
                        <dd>{fact.value}</dd>
                    </div>
                ))}
            </dl>

            {object.facts ? <p className="sky-object-blurb">{object.facts}</p> : null}
        </section>
    );
};

export default ObjectFactsCard;
